import { render, staticRenderFns } from "./Errors.vue?vue&type=template&id=9f627274&scoped=true&"
import script from "./Errors.vue?vue&type=script&lang=js&"
export * from "./Errors.vue?vue&type=script&lang=js&"
import style0 from "./errors.scss?vue&type=style&index=0&id=9f627274&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f627274",
  null
  
)

export default component.exports